import actions from "./actions";

const {FETCH_CLASS, FETCH_CLASSES, RESET_CLASS} = actions;
const initState = {
    classes: {
        page: 0,
         perPage: 35,
        data: [],
        total: 0
    },
    theClass: {_id: null}
};

const ClassReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_CLASSES:
            return {
                ...state,
                classes: data
            }
        case RESET_CLASS:
            return {
                ...state,
                theClass: initState.theClass,
            };
        case FETCH_CLASS:
            return {
                ...state,
                theClass: data,
            };
        default:
            return state;
    }
}

export default ClassReducer;
